export const Routes = {
  home: "/home",
};
